'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GettingStrategy = exports.GettingStrategy = {
  DEFAULT: 'default',
  RETURN_PATH_BY_DEFAULT: 'return-path-by-default',
  RETURN_PATH_BY_DEFAULT_WITHOUT_ERROR: 'return-path-by-default-without-error'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-multilanguage/dist/enums/getting-strategy.js
// module id = 254
// module chunks = 0